export const alertsOptions = [
  {
    label: 'Con alertas pendientes',
    value: 'any',
  },
  {
    label: 'Sin alertas pendientes',
    value: 'none',
  },
]
